import {cn} from '@/lib/utils' // adjust the import path of `cn` if needed
import React from 'react'

interface ISmallScreenMenuTriggerProps {
  isProductButtonShow: boolean
  isDropdownOpen: boolean
  activeProductColor: {hover: string}
  activeProductBgColor: string
  activeProductName?: string
  dir: 'ltr' | 'rtl'
  smallScreenButtonRef: React.RefObject<HTMLButtonElement | null>
  handleDropdownToggle: (event: React.MouseEvent<HTMLButtonElement>) => void
  handleKeyDown: (
    e: React.KeyboardEvent<HTMLButtonElement>,
    step: number,
  ) => void
}

export const SmallScreenMenuTrigger: React.FC<ISmallScreenMenuTriggerProps> = ({
  isProductButtonShow,
  isDropdownOpen,
  activeProductColor,
  activeProductBgColor,
  activeProductName,
  dir,
  smallScreenButtonRef,
  handleDropdownToggle,
  handleKeyDown,
}) => {
  return (
    <div
      className={cn(
        'absolute top-11 transition-all duration-300 ease-in-out transform opacity-100 w-[256px] z-10',
        isProductButtonShow
          ? dir === 'rtl'
            ? 'right-0 overflow-hidden'
            : 'translate-x-0 left-0'
          : dir === 'rtl'
            ? 'right-0 w-0'
            : '-translate-x-full',
      )}
      style={{
        backgroundColor: isDropdownOpen
          ? activeProductColor.hover
          : activeProductBgColor,
      }}
    >
      <button
        ref={smallScreenButtonRef}
        type="button"
        className={cn(
          'text-base leading-[48px] flex items-center justify-center px-2 gap-2 w-full focus:outline-none focus-visible:bg-white/10 wu-switcher-trigger',
          isProductButtonShow ? 'flex' : dir === 'rtl' ? 'hidden' : 'flex',
        )}
        onClick={handleDropdownToggle}
        onKeyDown={e => {
          if (isDropdownOpen && e.key === 'ArrowDown') {
            handleKeyDown(e, -1)
          }
        }}
        aria-label="small-screen-product-btn"
      >
        {activeProductName}
        <span
          className={cn(
            'wm-arrow-drop-down text-2xl transition-transform duration-300',
            isDropdownOpen && 'rotate-180',
          )}
        ></span>
      </button>
    </div>
  )
}
